import i18n from "@/i18n";

i18n.mergeLocaleMessage("pt-BR", {
  'every-owner': 'Todos os Clientes',
  login: {
    full_name: "SEU USUÁRIO",
    user: "seu usuário",
    password: "senha",
    forgot_password: "Esqueceu sua senha?",
    remember_user: "Lembrar meu usuário",
    integration_login: "A sessão expirou. Por favor, feche e abra novamente a janela da A de Agro",
    error: {
      invalid_credentials: "Credenciais inválidas. Tente novamente, por favor.",
      rate_limit: "Muitas tentativas de login. Tente novamente em {retry}.",
      retry_soon: "instantes",
      retry_seconds: "{count} segundo | {count} segundos",
      retry_minutes: "{count} minuto | {count} minutos"
    },
    footer: {
      "help-label": "Ajuda",
      "faq-label": "FAQ"
    }
  },
  user: {
    "my-account": "Minha conta",
    "user-form": {
      username: "Usuário do sistema",
      name: "Nome do usuário",
      email: "E-mail",
      "company-name": "Nome da empresa",
      "company-doc": "CNPJ",
      "company-phone": "Telefone",
      "company-address": "Endereço completo",
      "company-zipcode": "CEP",
      "company-title": "Empresa",
      'api-integration': 'Integração por API',
      'company-client-id': 'Chave de Acesso',
      'company-client-secret': 'Senha da Chave de Acesso',
      "my-data": "Meus Dados",
      "generate-secret": "Gerar Senha",
      "confirmation-secret-key": "Gerar Senha da Chave de acesso",
      "confirmation-body": "Deseja gerar uma nova senha? Isso invalidará a senha atual.",
    },
    "secret-key-modal": {
      title: "Senha da Chave de Acesso",
      label: 'Senha',
      "show-secret": "Mostrar",
      "hide-secret": "Esconder",
      "copy-label": "Copiar",
      copy: "Copiar",
      copied: "Copiado",
      "disclaimer-1": "A senha só é exibida uma única vez.",
      "disclaimer-2": "Por favor, certifique-se de armazená-la com cuidado!",
      "disclaimer-3": "Caso a mesma seja perdida, será necessário gerar uma nova senha.",
      close: "Fechar"
    },
    "btn-header-label": "Alterar senha",
  },
  sidebar: {
    owners: "Clientes",
    "farms-home": "Fazendas",
    analysis: "Análises",
    "add-owner": "Adicionar Cliente",
    toolbox: "Ferramentas",
    logout: "Sair",
    collapse: "Colapsar Menu",
    expand: "Expandir Menu",
    profile: "Meu Perfil",
    analitica: "Analítica",
    sentinela: "Sentinela",
    ruraluno: "rural.uno",
  },
  confirmation: {
    "title-default": "Aviso",
    "body-text-default": "",
    "button-primary-label": "Confirmar",
    "button-secondary-label": "Cancelar"
  },
  farms: {
    "owner-form": {
      title: "Cadastrar dados do cliente",
      "document-label": "documento",
      'owner-key-label': 'identificador',
      'owner-key-placeholder': 'identificador ex. regiao_norte, soja_2022, silva',
      "owner-label": "cliente",
      "tel-label": "TELEFONE",
      "phone-label": "CELULAR",
      "city-label": "MUNICÍPIO",
      "state-label": "ESTADO",
      "email-label": "e-mail",
      "admitted-label": "ADMITIDO",
      "edit-label": "Editar",
      "save-label": "SALVAR INFORMAÇÕES",
      "saving-informations-label": "Salvando...",
      "saved-informations-label": "Informações Salvas",
      "tel-error-message": "Por favor, insira um telefone válido",
      "phone-error-message": "Por favor, insira um celular válido",
      "phone-number-input": {
        "country-selector-label": "Código do país",
        "country-selector-error": "Selecione um país",
        example: "Exemplo: "
      }
    },
    "farm-item": {
      "farm-name": "Nome da fazenda",
      "territory-code": "Código territorial",
      "farm-area": "Área",
      "farm-location": "Município/Estado",
      "btn-edit": "Editar",
      "btn-add-analysis": "Adicionar análise",
      "btn-remove": "Remover",
      "btn-add-monitoring": "Adicionar Monitoramento",
      "analitica-denied": "Para ter acesso ao analitica, entre em contato conosco",
      "sentinela-denied": "Para ter acesso ao sentinela, entre em contato conosco",
    },
    "farm-form": {
      "owner-name": "Cliente",
      "owner-document": "CPF",
      "farm-location": "Município/Estado",
      "farm-area": "Área",
      "farm-name": "Nome da propriedade"
    },
    "farm-analysis-form": {
      "owner-name": "Cliente",
      "farm-name": "Nome da propriedade",
      culture: "Cultura",
      period: "Período",
      "crop-type": "Escolha um tipo de plantação",
      SOY: "SOJA",
      CORN: "MILHO INVERNO",
      SUGARCANE: "CANA-DE-AÇUCAR",
      "monitoring-year": "Ano do Monitoramento",
      "select-monitoring-year": "Escolha o ano do monitoramento",
    },
    "farm-draw-confirm": {
      title: "Confirmação da propriedade",
      "btn-save-label": "Salvar",
      "btn-next-label": "Próximo",
      "btn-edit-label": "Editar"
    },
    "farm-analysis-confirm": {
      ANALITICA: "Confirmação de análise",
      SENTINELA: "Confirmação de monitoramento",
      "btn-save-label": "Processar",
      "btn-cancel-label": "Cancelar"
    },
    "owner-select": {
      title: "Confirmar Cliente",
      label: "Cliente: (Opcional)",
      "no-owner": "Novo cliente - ou selecione",
      "no-owners": "Nenhum cliente encontrado",
      "loading-more-options": "Carregando mais clientes...",
      "btn-save-label": "Salvar",
      "btn-edit-label": "Voltar",
    },
    "farm-owner": "Fazendas de",
    "farm-total-area": "Área total: ",
    "no-farm-owner": "Fazenda do Cliente",
    "btn-back": "Voltar",
    "add-farm": "Adicionar Fazenda",
    "search-farm": "Buscar Fazenda",
    "search-placeholder": "Busque por fazenda, cidade ou estado",
    "farm-controller": {
      "confirmation-label":
        'Você confirma a criação da fazenda <strong style="color: inherit; font-weight: bolder;">{farmName}</strong> para <strong style="color: inherit; font-weight: bolder;">{ownerName}</strong>?',
      "confirmation-without-owner-label":
        'Você confirma a criação da fazenda <strong style="color: inherit; font-weight: bolder;">{farmName}</strong>?',
      "cancel-label": "Cancelar",
      "confirm-label": "Confirmar",
      "geometry-textarea": "Geometria GeoJSON "
    },
    "analysis-item": {
      "created-at-label": "Solicitado em",
      "crop-type-label": "Cultura",
      "period-label": "Período",
      ANALITICA: "Análise",
      SENTINELA: "Monitoramento",
      "crop-types": {
        SOY: "Soja",
        CORN: "Milho Inverno",
      },
      "analysis-status": "status",
      "analysis-active": "Monitoramento Ativo",
      "analysis-disabled": "Monitoramento Inativo",
    },
    "farm-delete-confirmation-title": "Exclusão de fazenda",
    "farm-delete-confirmation": "Confirma que deseja remover a fazenda: {farm} ?",
    "analysis-delete": {
      "button": "DELETAR",
      "title": "Deletar Análise",
      "text": "O processamento realizado por essa análise irá ser cobrado!",
    },
    "car-search": {
      title: "Busca por CAR",
      "input-label": "Digite o CAR da fazenda",
      "label": "CAR",
      "btn-save-label": "Buscar",
      "btn-cancel-label": "Cancelar"
    },
    "car-select": {
      "modal-title": "Escolha o CAR",
      "rural-code": "Código Car:",
      area: "Área da fazenda:",
      "tipo-imovel": "Tipo de imóvel:",
      "btn-close-label": "Cancelar",
      "warn-bloqued-farm": "A seleção desta fazenda está temporariamente bloqueada pois possui mais de 15 mil hectares, por favor entre em contato com os administradores.",
    },
  },
  core: {
    "input-cpf": {
      "invalid-cpf": "Por favor, insira um CPF válido."
    },
    "state-selector-controller": {
      placeholder: "ESTADO",
      "loading-placeholder": "Carregando..."
    },
    "city-selector-controller": {
      placeholder: "MUNICÍPIO",
      "loading-placeholder": "Carregando..."
    },
    "wrapped-gm": {
      "draw-polygon": "Desenhar Polígono",
      "paste-polygon": "Colar Polígono",
      "car": "Inserir por Car",
      "clear-drawing": "Limpar Desenho",
      "zoom-in": "Aumentar Zoom",
      "zoom-out": "Diminuir Zoom ",
      "search-placeholder": "Busque um local",
      language: "pt",
      region: "BR",
      latLngLabel: "lat: {lat} | lng: {lng}",
      "download-geojson": "Baixar como GeoJSON",
      'hide-label': 'Esconder Rótulos',
      'show-label': 'Mostrar Rótulos',
      'car-near': 'Obter CAR das proximidades',
      'remove-car-near': 'Remove CAR\'s das proximidades',
      'layer-order': 'Polígonos sobre a imgem',
    }
  },
  notifications: {
    success: {
      title: "Sucesso!",
      farmMessage: "Fazenda {farmName} criada com sucesso",
      analysisMessage: "Análise criada com sucesso",
      "owner-admitted-message": "Cliente(a) {name} admitido(a) com sucesso",
      "owner-unadmitted-message": "Admissão do(a) cliente(a) {name} removida com sucesso",
      "reset-password": "Por favor, verifique seu e-mail cadastrado!",
      "delete-farm": "Fazenda removida!",
      "owner-delete": "Cliente deletado com sucesso {name}!",
      "analysis-delete": "Análise deletada com sucesso!",
      "map-file-upload-success": "Arquivo enviado com sucesso!",
      "analysis-update": "Análise/Monitoramento atualizado com sucesso!",
    },
    warning: {
      title: "Atenção!"
    },
    error: {
      title: "Erro!",
      message: "Houve um erro no servidor, por favor tente novamente.",
      "owner-admitted-message": "Erro ao admitir cliente(a) {name}",
      "owner-unadmitted-message": "Erro ao remover admissão do(a) cliente(a) {name}",
      "user-change-password-message": "Erro ao alterar senha, por favor verifique as informações e tente novamente.",
      "user-change-password-incorrect-message": "Erro, a sua senha antiga está incorreta!",
      "user-save-password": "Erro, o token expirou ou é inválido, solicite alteração de senha novamente",
      "delete-farm": "Erro ao remover fazenda!",
      "owner-delete": "Erro ao deletar cliente {name}",
      "analysis-delete": "Erro ao deletar a análise!",
      "trial-farm-limit-exceeded": "Não foi possível criar a Fazenda pois estourou a cota de {farmsCount} fazenda(s). Para aumentar o limite ou fazer um upgrade da conta, contate o administrador do sistema!",
      "trial-analysis-limit-exceeded": "Não foi possível criar a Análise pois estourou a cota de {analysisCount} análise(s). Para aumentar o limite ou fazer um upgrade da conta, contate o administrador do sistema!",
      "product-not-allowed": "Entre em contato com nossa central de vendas para adquirir este produto",
      "map-file-upload-error": "Erro ao enviar arquivo!",
      "map-file-without-features": "O arquivo enviado não possui poligono!",
      "generate-secret-key-error": "Não foi possível gerar uma nova chave secreta: a companhia não existe",
      "generate-secret-key-other-error": "Não foi possível gerar uma nova chave secreta, por favor tente novamente",
      "search-by-car-empty": "Não foram encontradas fazendas com o código CAR informado, por favor tente novamente",
      "search-by-car-error": "Erro ao buscar fazendas!",
      "search-by-lat-lng-empty": "Não encontramos CAR para a localização selecionada",
      "search-by-lat-lng-error": "Erro ao buscar CARs no ponto, por favor, tente novamente",
      "invalid-geometry-intersection": "Geometria inválida: A geometria não pode ter intersecções.",
      "bulk-csv-file-converter-parse": "Erro ao converter os dados do arquivo. Por favor, verifique o conteúdo do mesmo",
    }
  },
  analysis: {
    "analysis-not-started": "Por favor, aguarde...",
    "go-back": "Voltar",
    "go-to-compare": "Ver comparativo",
    "farm-owner": "Propriedade de {ownerName}",
    "no-farm-owner": "Novo cliente - ou selecione",
    "farm-name": "Fazenda: ",
    "processing-message":
      "Esta análise ainda está em processamento. Por favor, aguarde...",
    "finished-with-success": "Finalizado com sucesso",
    "finished-with-error": "O processo foi finalizado com erro. Não se preocupe, você não será cobrado por este processo.",
    "loading-results": "Carregando resultados...",
    "tabs": {
      "summary": "Resumo",
      "weather": "Clima",
      "environmental": "Conformidade CAR",
    },
    summary: {
      "farm-area": "Área total",
      "arable-area": "Área agricultável",
      "crop-area": "Área de {crop_type}",
      yield: "Produtividade",
      production: "Produção",
      "average-planting-date": "Média plantio",
      "average-harvest-date": "Média colheita",
      city: "Município",
      state: "Estado",
      country: "País",
      "micro-region": "Microrregião",
      "yield-std": "Desvio Produtividade",
      "score-std": "Desvio Score",
      "crop-area-too-small": "O sistema não encontrou área significante de {crop_type} nesta fazenda.",
      "culture-type": "Cultura:",
      'yield-scores': 'Scores de Produtividade no ano-safra:',
    },
    "ndvi-chart": {
      "farm-label": "Fazenda - {crop_type}",
      "farm-label-not-confirmed": "Fazenda - cultura não confirmada"
    },
    step: {
      VISTA: 'Selecionando datas',
      CROP_SEG: 'Segmentando talhões',
      YIELDEST: 'Calculando produtividade',
      GET_VI: 'Localizando índices vegetativos',
      PLOT_DOCTOR: 'Localizando culturas',
      YIELD_SCORE: 'Calculando score',
      SUMMARY: 'Gerando arquivo com resultados'
    },
    status: {
      PROCESSING: 'Processando',
      FINISHED: 'Finalizado',
      ERROR: 'Erro'
    },
  },
  "analysis-delete": {
    "button": "DELETAR",
    "title": "Deletar Análise",
    "text": "O processamento realizado por essa análise irá ser cobrado!",
  },
  toolbox: {
    culture: "Cultura",
    owner: "Cliente",
    year: "Ano",
    monitoringSheet: "Sentinela - Planilha de Monitoramento",
    riskReport: "Analitica Risco - Planilha",
    cpfToCar: "CPF/CNPJ to CAR - Planilha",
    cpfToEg: "CPF/CNPJ to Grupo Econômico - Planilha",
    download: "Download",
    consult: "Consultar",
    clearQuery: "Limpar consulta"
  },
  sentinela: {
    search: "Pesquisar",
    harvest: "Safra",
    cropType: "Cultura",
    clear: "Limpar filtros",
    farmName: "Fazenda",
    ownerName: "Cliente",
    farmArea: "Área da Fazenda",
    cropArea: "Área da Cultura",
    harvestPercentage: "% Colheita",
    monitoringYear: "Ano Safra",
    'view-monitoring': 'Ver monitoramento'
  },
  owners: {
    name: "Nome",
    cpf: "CPF",
    ownerKey: "Identificador",
    email: "E-mail",
    phone: "Telefone",
    "cell-phone": "Celular",
    state: "Estado",
    city: "Município",
    "my-owners": "Meus Clientes",
    "all-owners": "Todos Clientes",
    "every-owner": "Todos Clientes",
    "no-result": "Nenhum cliente a ser mostrado...",
    "filter-owner": "Filtrar Clientes",
    "add-owner": "Adicionar Cliente",
    admitted: "Admitido",
    admit: "Admitir",
    unadmit: "Remover",
    "not-admitted": "Não Admitido",
    "all": "Todos",
    "farms-count": "Fazendas",
    "farm-area": "Área Total",
    "options": "Opções",
    filters: "Filtros",
    "filters-apply": "Fechar",
    "no-info": "Sem informação",
    "filter-clear": "Limpar Filtro",
    "btn-back": "Voltar",
    "owner-table": {
      admitted: "Admitido",
      name: "Nome",
      cpf: "CPF",
      ownerKey: "Identificador",
      farmCount: "Fazendas",
      farmArea: "Área Total",
      city: "Município",
      state: "Estado",
      actions: "Ações",
    },
    "owners": "Clientes",
  },
  "crop-types": {
    SOY: "Soja",
    CORN: "Milho",
    WINTER_CORN: "Milho Inverno",
    SUGARCANE: "Cana-de-Açúcar",
    PASTURE: "Pastagem",
    ANY: "Indeterminado",
    UNKNOWN: "Indeterminado",
    FOREST: "Formação florestal",
    RICE: "Arroz",
    COFFEE: "Café",
    CITRUS: "Citros",
    COTTON: "Algodão",
    EUCALYPTUS: "Silvicultura",
    NO_CROP: "Indeterminado",
    null: "Indeterminado"
  },
  "harvest-season": {
    SUMMER: "Principal",
    WINTER: "Inverno"
  },
  "harvest-season-unified": {
    SUMMER: "Primeira Safra",
    WINTER: "Segunda Safra"
  },
  "harvest-data-editor": {
    button: "Editar dados dos talhões",
    title: "Editar dados dos talhões",
    "col-label": "Talhão",
    "col-crop-type": "Cultura",
    "col-yield": "Produtividade (sc/ha)",
    "col-seeding": "Plantio",
    "col-harvest": "Colheita",
    save: "Salvar",
    cancel: "Cancelar",
    success: "Dados salvos. Os scores estão sendo recalculados...",
    "no-changes": "Nenhuma alteração para salvar.",
    "error-409": "A análise está em processamento. Tente novamente em instantes.",
    "error-404": "Talhão ou análise não encontrado.",
    "error-403": "Você não tem permissão para esta ação.",
    "error-generic": "Não foi possível salvar as alterações."
  },
  "crop-table": {
    label: "Rótulo",
    yield: "Produtividade",
    area: "Área",
    score: "Score",
    'city-score': 'Mun.',
    'microregion-score': 'Mic.',
    'state-score': 'Est.',
    'country-score': 'País',
    culture: "Cultura",
    seeding: "Plantio",
    harvest: "Colheita",
    production: "Produção",
    status: "Status",
    processing: "Processando",
    finished: "Finalizado com sucesso",
    error: "Finalizado com erro",
    'yield-csv': "Produtividade(scs/ha)",
    'area-csv': "Área(ha)",
    'production-csv': "Produção(scs)",
    'table-download': "Fazer Download da Informação da Tabela",
    'sentinela-prime': 'Sentinela Prime',
  },
  "analysis-status": {
    PROCESSING: "Processando",
    FINISHED: "Finalizado",
    ERROR: "Erro ao processar"
  },
  "logout-confirmation": {
    header: "Você confirma que quer sair?",
    body:
      "Não se preocupe, você não perderá nenhum processo ou dado do sistema.",
    logout: "Sair",
    "go-back": "Cancelar"
  },
  "geojson-validation": {
    "only-polygon": "Aceita apenas o tipo Polygon!",
    "invalid-geometry": "Geometria Inválida!",
    "only-one-polygon": "Apenas um Polygon é permitido!"
  },
  "change-password": {
    "alt-logo": "Logo agronow",
    "title-page": "Alterar senha",
    "password-label": "Nova senha",
    "btn-label": "confirmar",
    "btn-login-label": "Ir para o login",
  },
  "user-change-password": {
    "title-page": "Alterar senha",
    "password-label": "Senha atual",
    "new-password-label": "Nova senha",
    "confirm-new-password-label": "Confirme nova senha",
    "btn-label": "Salvar",
    "btn-back": "Voltar",
    errors: {
      "min-length": "A senha deve conter 8 ou mais caracteres.",
      "password-match": "A nova senha e a confirmação de senha precisam ser identicas.",
    },
  },
  "reset-password": {
    "title-page": "Redefinir Senha",
    "user-info-label": "Informação do Usuário",
    "user-info-placeholder": "Entre com o e-mail ou username",
    "confirm-label": "Confirmar",
    "cancel-label": "Cancelar",
    confirmation: "Pronto!",
    "confirmation-email": "Verifique seu e-mail",
    "confirmation-ok": "Ok!",
  },
  "charts": {
    "owners": "Clientes",
    "area": "Histograma de Área",
    "area-title": "Média de Área de {crop_type} / Cliente",
    "score": "Histograma de Score",
    "area-expansion": {
      "title": "Expansão/Retração - Área",
      "arable-area": "Cultivável",
      "crop-area": "Plantado",
      "total-area": "Total",
    },
    "score-area-comparative": {
      "title-city": "Cidade - Porcentagem de área por score",
      "title-micro-region": "Micro Região - Porcentagem de área por score",
      "title-state": "Estado - Porcentagem de área por score",
      "title-country": "País - Porcentagem de área por score",
      "label": "{area} da área de {cropType} em {year} está com score de produtividade entre {low} e {high}",
    },
    "comparative-score": {
      "title": "Evolução do Score",
      "score-city": "Score Município",
      "score-country": "Score Pais",
      "score-micro-region": "Score M. Região",
      "score-state": "Score Estado",
    },
    "yield-by-year": {
      "title": "Produtividade ao longo dos anos",
      "yield-in": "Produtividade em",
      "yield": "Produtividade",
    },
    "temperature": {
      "name": "Gráfico Temperatura (°C) x Meses",
      "current": "Ano atual",
      "historical": "Média Histórica",
    },
    "spi4": {
      "name": "Índice Padronizado de Precipitação (SPI-4) x Meses",
      "current": "Ano atual",
      "historical": "Média Histórica",
    },
    "months": {
      "1": "Jan",
      "2": "Fev",
      "3": "Mar",
      "4": "Abr",
      "5": "Mai",
      "6": "Jun",
      "7": "Jul",
      "8": "Ago",
      "9": "Set",
      "10": "Out",
      "11": "Nov",
      "12": "Dez",
    },
    "temperature-chart": {
      "empty-data": "Dados sobre o clima indisponíveis no momento.",
    },
    "pace": {
      "crop-type-title": "Andamento plantio e colheita - cultura confirmada",
      "annual-title": "Andamento plantio e colheita - cultura elegível",
      "observablePlanted": "Data observada × área plantada",
      "avgPlantingPlanted": "Data média de plantio × área plantada",
      "avgHarvestHarvested": "Data média de colheita × área colhida",
      "date": "Data",
      "area": "Área (ha)",
      "targetArea": "Área elegível"
    },
  },
  "owners-delete": {
    "title-page": "Deletar Cliente",
    "owner-name": "Nome: {name}",
    "information": "Todas as análises geradas para este cliente serão cobradas!",
    "confirm-label": "Confirmar",
    "cancel-label": "Cancelar",
  },
  "filter": {
    "title-page": "Filtro",
    "confirm-label": "Confirmar",
    "cancel-label": "Cancelar",
    "score-chart": {
      "culture": "Cultura",
      "analysis-year": "Ano de Análise",
      "analysis-year-none": "Todos os anos",
      "harvest-season": "Época de cultura",
      "only-user-owners": "Apenas Meus Clientes"
    },
    "score-area-comparative": {
      "yield-score-type": "Tipo de Score",
    }
  },
  "yield-score": {
    YIELD_SCORE_CITY: "Cidade",
    YIELD_SCORE_MICRO_REGION: "Região",
    YIELD_SCORE_STATE: "Estado",
    YIELD_SCORE_COUNTRY: "País"
  },
  "compare-farms-owners": {
    "loading": "Carregando comparativo...",
    "load-error": "Não foi possível carregar o comparativo. Tente novamente.",
    "analysis-year": "Ano",
    "average-planting-date": "Plantio",
    "average-harvest-date": "Colheita",
    "cycle": "Ciclo",
    "average-yield": "Produtividade média",
    "production": "Produção",
    "compare": "Comparativo",
  },
  monitoring: {
    "monitoring-not-started": "Por favor, aguarde...",
    "cutNumber": "\n Nº corte: {cutCaneDate}",
    "pace": {
      "annual": "Área elegível",
      "crop-type": "Área confirmada",
    },
    summary: {
      "average-planting-date": "Data média de plantio (ano atual)",
      "average-planting-date-last-year": "Data média de plantio (último ano)",
      "average-harvest-date": "Data média de colheita (ano atual)",
      "average-harvest-date-last-year": "Data média de colheita (último ano)",
      "average-yield": "Produtividade",
      "area": "Área Total",
      "arable-area": "Área Cultivável",
      "crop-area": "Área {crop_type}",
      "harvest-area-analysis": "Área em Análise",
      "expansion-harvest-area": "Variação da área em análise",
    },
    "stage-steps": {
      PLANTED: "Plantio",
      DEVELOPMENT: "Desenvolvimento",
      MATURATION: "Maturação",
      GERMINATION: "Brotação",
      DRYING: "Secagem",
      HARVESTED: "Colheita",
    },
    "stage-steps-letter": {
      PLANTED: "P",
      DEVELOPMENT: "D",
      MATURATION: "M",
      GERMINATION: "B",
      DRYING: "S",
      HARVESTED: "C",
    },
    "evolution-chart": {
      "chart-label": "Produtividade",
      "last-year-label": "Produtividade na Última Safra",
    },
    'select': '',
    'cropLabel': 'Rótulo',
    "area": "Área",
    "yield": "Produtividade",
    "seeding-date": "Plantio",
    "estimated-harvest-date": "Colheita",
    "cropStages": "Estágio",
    "cropType": "Cultura",
    "info": "Info",
    "crop-type-undefined": "Indefinido",
    "crop-type-nothing": "Sem plantio",
    "estimated-harvest-date": {
      "label": "Data Estimada de Colheita",
      "undefined": "Indefinida",
    },
    "time-line-subtitle": {
      SOY: "Soja",
      "NOT-SOY": "Não definido",
      CORN: "Milho Inverno",
      "NOT-CORN": "Indefinido",
      undefined: "Não Definido",
      SUGARCANE: "Cana-de-Açúcar",
      "NOT-SUGARCANE": "Não definido",
    },
    "last-modified": "Atualizado em: ",
    "last-image": "Última Imagem: ",
    "last-image-title": "Área da fazenda coberta pela imagem: {percentage}",
    "still-monitoring-label": "MONITORANDO",
    "still-monitoring-title": "Esta fazenda está sendo monitorada",
    "finished-monitoring-label": "FINALIZADO",
    "finished-monitoring-title": "O monitoramento já foi finalizado",
    "waiting-processing": "Aguardando processamento...",
    tabs: {
      "evolution": "Evolução",
      "weather": "Clima",
      "environmental": "Conformidade CAR",
      "crops": "Talhões",
    },
    'last-image-info': {
      'sentinela-standard-title': 'Sentinela Convencional',
      'sentinela-prime-title': 'Sentinela Prime',
      'last-image-label': 'Última Imagem:',
      'visible-percentage-label': 'Porcentagem visível:',
      'sentinela-standard-description': 'Monitoramento tradicional com dados abertos. Novos dados de satélite a cada 5 dias no melhor cenário.',
      'sentinela-prime-description': 'Monitoramento com dados privados de alta resolução. Novos dados de satélite a cada 1 dia no melhor cenário.',
    },
    'finish-warning': {
      'title': 'Deseja finalizar manualmente o monitoramento?',
      'text': 'Você é um administrador do sistema e por isso pode finalizar manualmente o monitoramento. Após finalizado, a análise não será mais atualizada. Essa ação NÃO poderá ser desfeita por você.',
      'confirm': 'Sim',
      'error-message': 'Não foi possível finalizar o monitoramento: {message}',
    },
    'update':{
      'title': 'Exeutar rotina de atualização',
      'text': 'Deseje executar a rotina diária de atualização agora?',
      'confirm': 'Sim',
      'success': 'Monitoramento atualizado com sucesso',
    },
    'crop-reset': {
      'title': 'Resetar Talhão',
      'text': 'Deseja resetar os dados deste talhão? Os resultados só estarão dispoíveis após a atualização diária ou manual do monitoramento?',
      'confirm': 'Sim',
      'success': 'Talhão resetado com sucesso',
    },
  },
  'map-upload': {
    send: 'Enviar',
    cancel: 'Cancelar',
    'drop-files': 'Clique ou arraste e solte os arquivos aqui',
    file: 'Arquivo:',
  },
  "farms-home": {
    'title': 'Fazendas',
    'farm-name': 'Fazenda',
    'territory-code': 'Código territorial',
    'owner-name': 'Cliente',
    'area': 'Área',
    'lng-lat-title': 'Lng/Lat',
    'lng-lat-placeholder': 'Lng/Lat Ex: -54.4332, -45.4422',
    'state-acronym': 'Estado',
    'city': 'Município',
    'monitoring': 'Monitoramento',
    'analyses': 'Análises',
    'actions': 'Ações',
    'create-farm': 'Adicionar Fazenda',
    'only-user-farms': "Minhas Fazendas",
    'only-active-monitoring': "Somente Monitoramento Ativo",
    'delete-farm': 'Excluir Fazenda',
    'farm-area': 'Área da Fazenda',
    'farm-min-area': 'Mínimo',
    'farm-max-area': 'Máximo',
    'clear-filter': 'Limpar filtros',
    "farm-delete-confirmation-title": "Remover Fazenda",
    "farm-delete-confirmation": "Você deseja remover a fazenda {farm} ?",
    "monitoring-year": "Ano Monitorado: {year}",
    "analyses-years": "Anos Analisados: {years}",
    "analyses-list": {
      analitica: "Análises",
      sentinela: "Monitoramentos",
      "no-analysis": "Nenhuma análise a ser mostrada...",
    },
    "agro-cards": {
      analyses: "Análises",
      areas: "Área Cadastrada",
      "areas-unit": "ha",
      "areas-unit-larger": "k/ha",
      farms: "Fazendas",
      monitoring: "Monitoramentos",
      processing: "Processamentos",
    },
    "table-analyses-status": {
      "farmName": "Fazenda",
      "ownerName": "Cliente",
      "cropType": "Cultura",
      "analysisType": "Tipo",
      "stepMessage": "Status",
    },
    "status-modal": {
      title: "Processos",
      farm: "Fazenda",
      owner: "Cliente",
      status: "Status",
      "crop-type": "Tipo de Cultura",
      "crop-types": {
        SOY: "Soja",
        CORN: "Milho",
        SUGARCANE: "Cana-de-Açúcar",
        ANY: "Tipo de Cultura"
      },
    },
    "farm-upload-modal": {
      title: "Cadastro em lotes - Arquivo CSV",
      'farm-name': 'Nome da Fazenda',
      'owner-name': 'Nome do Cliente',
      'owner-id': 'Id do Cliente',
      'farm-shape-label': 'Shape da Fazenda',
      'farm-shape-point': 'Ponto',
      'farm-shape-car': 'Código do CAR',
      'farm-shape-sigef': 'Código da Parcela INCRA',
      'farm-shape-geom': 'Geometria (polígono GeoJSON)',
      'crop-type': 'Cultura',
      'soy': 'Soja',
      'corn': 'Milho',
      'product': 'Produto',
      'product-analitica': 'Análise 4 últimas safras',
      'product-sentinela': 'Monitoramento',
      'example-table': 'Exemplo dos dados em formato de tabela:',
      'example-file': 'Exemplo do arquivo a ser fornecido:',
      'btn-upload-label': 'Selecionar arquivos',
      'btn-cancel-label': 'Cancelar',
    },
    'bulk-uploader-validator': {
      title: 'Cadastro em lotes - Arquivo CSV',
      'available-data': 'Dados fornecidos:',
      field: {
        'farmName': 'Fazenda',
        'ownerId': 'ID Cliente',
        'ownerName': 'Nome Cliente',
        'lat': 'Lat',
        'lng': 'Lng',
        'carCode': 'Código CAR',
        'incraAllotment': 'Código da Parcela Incra',
        'geom': 'Geometria',
        'analitica': 'Analitica',
        'sentinela': 'Sentinela',
        'cropType1': 'Cultura 1',
        'cropType2': 'Cultura 2',
      },
      'status-label': 'Status',
      status: {
        VALID: 'Pronto para processar',
        INVALID_POINT: 'Falta lat ou lng',
        NOT_ONLY_ONE_GEOM: 'Por favor, use apenas um metódo para selecionar a geometria da fazenda',
        NO_OWNER_ID: 'Falta ID do Cliente',
        NO_FARM_NAME: 'Campo geom requer um nome para fazenda',
        INVALID_GEOMETRY: 'Campo geom não é um Polígono válido no formato GeoJSON',
        NO_CROP_TYPE: 'Campo crop_type_1 ou crop_type_2 é necessário para as análises',
      },
      'validation-stats': '{valid} linhas válidas. {invalid} linhas inválidas que serão ignoradas.',
      'btn-continue-label': 'Fazer Upload',
      'btn-cancel-label': 'Cancelar',
      'btn-close-label': 'Fechar',
      'owner-api-response-status': {
        BACKEND_ERROR: 'Erro na comunicação. Por favor, tente novamente.',
        SUCCESS: 'Cliente cadastrado.',
        ERROR: 'Erro ao cadastrar cliente.',
        ALREADY_CREATED: 'Cliente previamente cadastrado.',
        NOT_CREATED: 'Erro ao cadastrar. Por favor, verifique os dados.',
      },
      'farm-api-response-status': {
        BACKEND_ERROR: 'Erro na comunicação. Por favor, tente novamente.',
        SUCCESS: 'Fazenda cadastrada.',
        ERROR: 'Erro ao cadastrar fazenda.',
        ALREADY_CREATED: 'Fazenda previamente cadastrada.',
        NOT_CREATED: 'Erro ao cadastrar. Por favor, verifique os dados.',
        NOT_FOUND_IN_DATABASE: 'Código não encontrado na base dados.',
      },
      'analysis-api-response-status': {
        BACKEND_ERROR: 'Erro na comunicação. Por favor, tente novamente.',
        SUCCESS: 'Processamento iniciado para {type} {crop_type}.',
        ERROR: 'Erro ao iniciar processamento para {type} {crop_type}.',
        ALREADY_CREATED: 'Processamento previamente cadastrada.',
        NOT_CREATED: 'Erro ao cadastrar. Por favor, verifique os dados.',
      },
    },
    tabs: {
      'table-label': 'Tabela',
      'map-label': 'Mapa',
    },
    "farms-map": {
      "farm-name": "Fazenda",
      "owner": "Cliente",
      "city-state": "Cidade/Estado",
      "area": "Área",
      "view-more": "Ver mais",
    },
    filters: "Filtros",
  },
  "table-pagination": {
    "return-five": "retornar cinco páginas",
    "previous-page": "Página anterior",
    "go-to-page": "Ir para página {pageNumber}",
    "go-to-page-number": "Digitar página",
    "page-size": "Quantidade de itens por página",
    "next-page": "Próxima página",
    "next-five": "Avançar 5 páginas",
  },
  "environmental": {
    "car-infractions": {
      "loading": "Carregando informações",
      "no-infractions-yet": "A análise de conformidade ainda não foi gerada para este ano. Click no botão abaixo para gerar a análise",
      "generate": "Gerar análise Ambiental",
      "infractions-list": "Lista de divergências encontradas:",
      "explantion-ul-title": "Resultados de comparação com os dados disponibilizados pelo o sistema CAR. A alteração pode significar três coisas:",
      "explanation-li-one": "O agricultor plantou ou abriu área que não deveria;",
      "explanation-li-two": "A base de dados do CAR está desatualizada;",
      "explanation-li-three": "Ocorreu um falso positivo na plataforma.",
      "no-infractions-found": "Nenhuma infração detectada de acordo com a base de dados do CAR mais recente.",
      "download-image": "Imagem",
      "download-geojson": "Geojson",
      "show-in-map": "Ver no Mapa",
      "hide-in-map": "Esconder",
      "map-legend": "Legenda - Ambiental",
    },
    "car-infractions-modal": {
      "title": "Solicitar análise Ambiental",
      "years-select": "Selecione os anos:",
      "all-years": "Todos os anos",
      "just-one": "Apenas",
      "confirm": "Confirmar",
      "cancel": "Cancelar",
    },
    "car-infractions-table": {
      "formattedArea": "Área (ha)",
      "infractionsTypeTranslated": "Divergência",
      "cropLabel": "Talhão",
      "formattedCropArea": "Área talhão (ha)",
      "cropTypeTranslated": "Cultura",
    },
    'infractions-type': {
      'APP': 'Área de proteção permanente',
      'LEGAL_RESERVE': 'Reserva Legal',
      'INFRACTION': 'Divergência',
    },
  },
  "result-summary": {
    "customer-name": "Cliente",
    "territory-name": "Fazenda",
    "harvest-season": "Safra analisada",
    "displayed-harvest": "Safra exibida",
    "crop-type": "Cultura",
    "area": "Área",
    "area-percentage": "Percentual da área",
    "arable-area": "Área cultivável",
    "summary": "Resumo culturas",
    "main-crop-type": "Análise de {crop-type}",
  },
  "credit": {
    "score-title": "Score Operacional",
    "score": {
      "general": "Score Geral",
      "track_record": "Track Record",
      "scale": "Escala",
      "zone": "Produtividade",
      "cluster": "Cluster",
      "homogeneity": "Homogeneidade",
      "balance": "Equilíbrio",
      "weather": "Climático",
    },
    "score-not-found": "Não há informações suficientes para gerar os scores.",
    "score-not-ready": "Ainda estamos gerando os scores, por favor, aguarde.",
  },
  "crop-update": {
    "text-crop-override": "Redesenhando talhões: {farm} - {cropType} - {year}",
    "btn-back": "Voltar",
    "btn-update-crops": "Atualizar talhãos",
    "crop-drawer": {
      "all-years": "Atualizar os talhões de todos os anos",
      "btn-upload-file": "Subir arquivo com talhões",
      "btn-update": "Atualizar",
      "btn-show-result": "Mostrar resultado",
      "btn-hide-result": "Esconder resultado",
      "text-crop-list": "Novos talhões",
      "text-crops": "Talhão {index} de {area} ha",
      "text-no-crops": "Nenhum talhão adicionado. Desenhe ou faça o upload de uma Feature Collection com a propriedade `type=CROP`."
    }
  },
  'info-tooltip': {
    ndvi: 'O Índice de Vegetação da Diferença Normalizada (NDVI - Normalized Difference Vegetation Index) é um indicador da biomassa fotossinteticamente ativa que varia de 0 a 1. Quanto maior o valor do NDVI, maior será a quantidade vegetativa. Para uma interpretação mais precisa, é necessário considerar os fatores edafoclimáticos, bem como peculiaridades da região e da estação do ano.',
    spi: 'O Índice Padronizado de Precipitação (SPI - Standardized Precipitation Index) mede o desvio em relação à precipitação mensal histórica de 20 anos. O SPI varia de -2.5 a +2.5, onde valores abaixo de -1.0 indicam seca e seu nível de severidade. Valores entre -1 e 1 são tidos como normais.',
    stages: {
      PLANTED: 'Data estimada de plantio da cultura.',
      DEVELOPMENT: 'Indicação da fase vegetativa da cultura por meio do aumento do NDVI.',
      MATURATION: 'Estimativa da data do fim da fase vegetativa e início da fase reprodutiva (floração).',
      DRYING: 'Estimativa da data do fim da fase de enchimento dos grãos e início da senescência da cultura.',
      HARVESTED: 'Data de colheita estimada após o ciclo completo da cultura.',
    },
    'credit-trust': {
      general: 'Média dos Scores Operacionais',
      balance: 'Expansão ou retração da área da cultura nos anos-safra analisados.',
      climate: 'Histórico de chuvas e temperaturas na área do território comparado através da evapotranspiração da planta, de acordo com os momentos mais importantes para evolução vegetativa da planta.',
      cluster: 'Relevância da cultura analisada dentro da região que o território se encontra.',
      homogeneity: 'Homogeneidade da produtividade da cultura entre os talhões e entre os anos-safra analisados.',
      scale: 'Relevância da cultura em relação a área total do território nos anos-safra analisados.',
      yield: 'Produtividade da cultura nos anos-safra analisados comparada com a produtividade da cultura na região.',
      trackRecord: 'Relevância da cultura em relação a área agricultável do território nos anos-safra analisados.',
    },
    'yield-scores': {
      city: 'Produtividade da cultura no ano-safra comparada com o município.',
      microregion: 'Produtividade da cultura no ano-safra comparada com a microrregião.',
      state: 'Produtividade da cultura no ano-safra comparada com o estado.',
      country: 'Produtividade da cultura no ano-safra comparada com o país.',
    },
    'version': {
      'pipeline-label': 'Versão do pipeline',
      'crop-id-label': 'Versão do CropId',
      'yieldest-label': 'Versão do Yieldest',
      'version-label': 'Versionamento'
    },
    'biomas-label': 'Projeto MapBiomas – Coleção 7.1 da Série Anual de Mapas de Uso e Cobertura da Terra do Brasil, acessado em 15/04/2023 através do link: https://brasil.mapbiomas.org/produtos# -- Nossos modelos foram treinados e validados com diversas fontes de dados, públicas e privadas, incluindo o MapBiomas'
  }
});

i18n.mergeNumberFormat("pt-BR", {
  "rounded-number": {
    style: "decimal",
    maximumFractionDigits: 0
  }
});

i18n.mergeDateTimeFormat("pt-BR", {
  short: {
    day: "numeric",
    month: "numeric",
    year: "numeric"
  },
  long: {
    year: "numeric",
    month: "short",
    day: "numeric",
    weekday: "short",
    hour: "numeric",
    minute: "numeric"
  },
  'datetime-short': {
    year: "numeric",
    month: "2-digit",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  }
});

